import dayjs from 'dayjs';

export const DATE_RANGE_DEFAULT_VALUES = [
  dayjs().startOf('day'),
  dayjs().endOf('day'),
];

export const DATE_PICKER_DEFAULT_VALUE = dayjs().startOf('day');
